var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"max-width":_vm.width,"type":"card","id":"card-skeleton-loader"}})
}
var staticRenderFns = []

export { render, staticRenderFns }